export const CONTACT = {
  SUPPORT_EMAIL: 'support@pestshare.com',
} as const
